const lodash = require('lodash');
const deps = [];
lodash.noConflict();
module.exports = angular.module('bench.vendor.lodash', deps).factory('_', () => lodash);
